// extracted by mini-css-extract-plugin
module.exports = {"background":"style__background__KWkJA","wrapper":"style__wrapper__hM2zx","body":"style__body__Z3zFD","nav":"style__nav__C7blP"};